// extracted by mini-css-extract-plugin
export default {"shimmerText":"zqanYO5WYf0G7pxrFjdd","shimmer":"U6mGKUeNq_8QEuJ2Ntw5","shimmerPaused":"rGqoZrMxwLUngHlj6sMh","staticText":"QFFPnywRzECKWtJzWzwb"};